module.exports = __webpack_public_path__ + "static/img/sensor_ultrassonico_hc_sr04-2.16e8d6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensor_ultrassonico_hc_sr04-2.svg
// module id = 12iF
// module chunks = 0